module.exports = __webpack_public_path__ + "static/16-709c36deec0e962529f8e88fdd36c4f3.jpg";